export class DataProtectionNoticeCountriesListLoad {
  public static readonly type = '[DataProtectionNoticeCountriesList] Load';
}

export class DataProtectionNoticeCountriesListInitialState {
  public static readonly type = '[DataProtectionNoticeCountriesList] Set Initial State';
}
